import { DashboardShell } from "@/components/dashboard-shell"
import { ScheduleCalendar } from "@/components/schedule/schedule-calendar"
import { Card } from "@/components/ui/card"
import { createFileRoute } from "@tanstack/react-router";
import {
  RouteLoading,
  CalendarLoadingSkeleton,
} from "@/components/route-loading";

export const Route = createFileRoute("/schedule")({
  component: SchedulePage,
  head: () => ({ meta: [{ title: "Schedule" }] }),
  pendingComponent: SchedulePending,
});

function SchedulePage() {
  return (
    <DashboardShell>
      {/* Fills the main pane exactly on phones and short landscape screens, so
          the calendar scrolls inside itself instead of the page scrolling. */}
      <Card className="flex-col gap-0 p-0 lg:flex-row max-md:min-h-0 max-md:flex-1 md:[@media(min-height:481px)]:h-[calc(100svh-5.5rem)] md:[@media(min-height:481px)]:min-h-[600px] md:[@media(max-height:480px)]:min-h-0 md:[@media(max-height:480px)]:flex-1">
        <ScheduleCalendar />
      </Card>
    </DashboardShell>
  )
}

// Shown while this route's chunk (and the ReUI components in it)
// downloads. Was src/app/schedule/loading.tsx.
function SchedulePending() {
  return (
    <RouteLoading>
      <CalendarLoadingSkeleton />
    </RouteLoading>
  );
}
